import { ApplicationViewParams } from '@lk/api'
import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const applicationViewGeneral = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_GENERAL',
  async ({ handleError, ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view(params.page, params)

    if (result.success) {
      return result.data
    }
    if (handleError) {
      return handleError(result)
    }
    return rejectWithValue(result.error.message)
  },
)

export const applicationViewBase = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_BASE',
  async ({ handleError, ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('base', params)

    if (result.success) {
      return result.data
    }
    if (handleError) {
      return handleError(result)
    }
    return rejectWithValue(result.error.message)
  },
)

export const applicationViewBic = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_BIC',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('bic', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewCollaterals = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_COLLATERALS',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('collaterals', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewComittee = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_COMMITTEE',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('comittee', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewComitteedetails = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_COMITTEEDETAILS',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('comitteedetails', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewDecisioneligible = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_DECISIONELIGIBLE',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('decisioneligible', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewDecisions = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_DECISIONS',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('decisions', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewDmlog = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_DMLOG',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('dmlog', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewGrpmembers = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_GRPMEMBERS',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('grpmembers', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewLinkedfiles = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_LINKEDFILES',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('linkedfiles', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewPrintappbic = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_PRINTAPPBIC',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('printappbic', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewCustfields = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_CUSTFIELDS',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('custfields', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewPrintappdetails = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_PRINTAPPDETAILS',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('printappdetails', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationViewStatehistory = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_STATEHISTORY',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('statehistory', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationPrint = createAsyncThunk<any, ApplicationViewParams, ThunkApi>(
  '[APPLICATION/VIEW] VIEW_STATEHISTORY',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.view('printappdetails', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const destroyApplicationViewBase = createAction('[APPLICATION] DESTROY_APPLICATION_BASE')
export const destroyApplicationViewCustFields = createAction('[APPLICATION] DESTROY_APPLICATION_CUSTOM_FIELDS')
